export default {
    STORE_KEY: [],
    TAGS: [
        "",
        "Новинка",
        "Лимитированная коллекция",
        "Лидер продаж"
    ],
  };